import Vue from "vue";
import ja from "vee-validate/dist/locale/ja.json";
import en from "vee-validate/dist/locale/en.json";
import zhTw from "vee-validate/dist/locale/zh_TW.json";
import { extend, localize } from "vee-validate";
import { required, max, min, email, alpha_num, confirmed } from "vee-validate/dist/rules";

// 日本語にローカライズ
localize("ja", ja);

// Install default rules.
extend("required", required);
extend("max", max);
extend("min", min);
extend("email", email);
extend("alpha_num", alpha_num);
extend("confirmed", confirmed);

localize({
  ja: {
    messages: ja.messages,
    fields: {
      customForm: {
        required: "入力が必要です",
        email: "メールアドレスを入力してください",
        max: "文字数が上限を超えています",
        alpha_num: "半角英数字以外は使用できません",
        confirmed: "パスワードと確認用パスワードが一致しません",
        nameSyntax:
          "利用できない文字が含まれています、利用できる文字種は入力フォームの?アイコンから確認ください",
        emojiSyntax: "絵文字は使用できません",
        passwordSize: "8〜32文字で入力してください",
        required_upper: "大文字を含め入力してください",
        required_lower: "小文字を含め入力してください",
        required_num: "数字を入力してください",
        httpFormat: "http:// または https:// で開始してください",
        dotFormat: "終了文字に . を指定することはできません",
      },
    },
  },
  en: {
    messages: en.messages,
    fields: {
      customForm: {
        required: "入力が必要です",
        email: "メールアドレスを入力してください",
        max: "文字数が上限を超えています",
        alpha_num: "半角英数字以外は使用できません",
        confirmed: "パスワードと確認用パスワードが一致しません",
        nameSyntax:
          "利用できない文字が含まれています、利用できる文字種は入力フォームの?アイコンから確認ください",
        emojiSyntax: "絵文字は使用できません",
        passwordSize: "8〜32文字で入力してください",
        required_upper: "大文字を含め入力してください",
        required_lower: "小文字を含め入力してください",
        required_num: "数字を入力してください",
        httpFormat: "http:// または https:// で開始してください",
        dotFormat: "終了文字に . を指定することはできません",
      },
    },
  },
  zhTw: {
    messages: zhTw.messages,
    fields: {
      customForm: {
        required: "入力が必要です",
        email: "メールアドレスを入力してください",
        max: "文字数が上限を超えています",
        alpha_num: "半角英数字以外は使用できません",
        confirmed: "パスワードと確認用パスワードが一致しません",
        nameSyntax:
          "利用できない文字が含まれています、利用できる文字種は入力フォームの?アイコンから確認ください",
        emojiSyntax: "絵文字は使用できません",
        passwordSize: "8〜32文字で入力してください",
        required_upper: "大文字を含め入力してください",
        required_lower: "小文字を含め入力してください",
        required_num: "数字を入力してください",
        httpFormat: "http:// または https:// で開始してください",
        dotFormat: "終了文字に . を指定することはできません",
      },
    },
  }
});

let LOCALE = "ja";
Object.defineProperty(Vue.prototype, "locale", {
  get() {
    return LOCALE;
  },
  set(val) {
    LOCALE = val;
    localize(val);
  },
});
